import React from "react";
import PropTypes from "prop-types";
import iconArrowDown from "../assets/icon_chevron_down.svg";
import "./SearchBrandMoreButton.scss";

function SearchBrandMoreButton({ onClick }) {
  return (
    <div className="search-brand-more-btn" onClick={onClick}>
      더보기
      <img src={iconArrowDown} alt="더보기" />
    </div>
  );
}

SearchBrandMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SearchBrandMoreButton;
